export default __webpack_public_path__ + "static/media/pic2.de959072.jpg";